import React, { useState, useEffect } from "react";
import { Button, TextField, Container, Typography, Box, Grid, Alert, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";


const Register = ({ onRegisterSuccess }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    username: "",
    first_name: "",
    last_name: "",
    user_type: "test_taker",
    school_district: "1",
    phone_number: "",
    password: "",
    password_confirm: "",
    district_code: ""
  });
  const [charLen, setCharLen] = useState(false);
  const [charCombo, setCharCombo] = useState(false);
  const [uniqPass, setUniqPass] = useState(false);
  const [passMatch, setPassMatch] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);

  const schoolDistricts = [
    {
      value: '1',
      label:'CVESD'
    },
    {
      value:'4',
      label: 'YMCA-SD'
    }
  ]

  const [error, setError] = useState("");
  
  // Check Password Requirements
  useEffect(() => {
    if (formData['password'].length >= 8) {
      setCharLen(true);
    } else {setCharLen(false);}

    if (/\d/.test(formData['password']) && /[a-zA-Z]/.test(formData['password'])) {
      setCharCombo(true);
    } else {setCharCombo(false);}
    
    if (formData['email'] !== formData['password']) {
      setUniqPass(true);
    } else {setUniqPass(false);}

    if (formData['password'] === formData['password_confirm'] && formData['password'] !== '') {
      setPassMatch(true);
    } else {setPassMatch(false);}

    if(charCombo && charLen && uniqPass && passMatch){setCanSubmit(true);}else{setCanSubmit(false);}
  }, [formData, charCombo, charLen, uniqPass, passMatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "email") {
      setFormData({ 
        ...formData, 
        email: value.toLowerCase(),
        username: value.toLowerCase()
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormData({...formData, ['username']: formData['email']});
    if (formData.password !== formData.password_confirm) {
      setError("Passwords do not match.");
    } else {
    try {
      const verification = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/verify-admin/`, formData, {
        headers: { "Content-Type": "application/json" },
      })
      if (verification.status === 200) {
        try {
          const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/register/`, formData, {
            headers: { "Content-Type": "application/json" },
          });
          if (response.status === 201) {
            onRegisterSuccess(); // Redirect or notify success
            navigate('/')
          }
        } catch (err) {
          setError("Registration failed. Please check your inputs. (password must be at least 8 characters or email is already registered)")
        }
      } else {
          setError("Invalid Administrator Code!")
      } 
    } catch (err) {
      setError("Invalid Administrator Code!");
    }}
  };

  return (
    <Box>
    <Box sx={{
      textAlign:'center',
      bgcolor:'primary.dark',
      p:4
    }}>
      <Typography variant="h2" sx={{fontWeight:650, color:'white', cursor:'pointer'}} onClick={() => navigate('/')}>ExamPortal</Typography>
      <Typography variant="h6" sx={{color:'white'}}>Efficient, Secure, and Painless Pre-Employment Testing</Typography>
    </Box>
    
    <Container maxWidth="sm">
      <Box mt={5}>
        <Typography variant="h4" gutterBottom sx={{mb:3}}>
          Register
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
            <TextField
              select
              label="School District"
              name="school_district"
              value={formData.school_district}
              onChange={handleChange}
              sx={{ width: '100%' }}
              SelectProps={{
                native: true,
              }}
              required
            >
              {schoolDistricts.map((option) => (
                <option key={option.label} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
            <TextField
              label="District Code"
              name="district_code"
              value={formData.district_code}
              onChange={handleChange}
              sx={{ width: '100%' }}
              required
            />
            </Grid>
            <Grid item xs={12} sm={6} sx={{mt:3}}>
              <TextField
                fullWidth
                label="First Name"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{mt:3}}>
              <TextField
                fullWidth
                label="Last Name"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone Number"
                name="phone_number"
                type="tel"
                value={formData.phone_number}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sx={{mt:3}}>
              <TextField
                fullWidth
                label="Password"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Confirm Password"
                name="password_confirm"
                type="password"
                value={formData.password_confirm}
                onChange={handleChange}
                required
              />
            </Grid>
          </Grid>
          <Typography sx={uniqPass ? ({mt:2, color:'green'}) : ({mt:2, color:'grey'})}>Password must be different than email</Typography>
          <Typography sx={charLen ? ({color:'green'}) : ({color:'grey'})}>Password must be at least 8 characters</Typography>
          <Typography sx={charCombo ? ({color:'green'}) : ({color:'grey'})}>Password must contain at least 1 digit and 1 letter</Typography>
          <Typography sx={passMatch ? ({color:'green'}) : ({color:'grey'})}>Passwords must match</Typography>
          {error && <Alert severity="error" sx={{ mt: 2 }} onClose={() => {setError('')}}>{error}</Alert>}
          <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 3, mb:2 }} disabled={canSubmit===false}>
            Register
          </Button>
        </form>
      </Box>
    </Container>
    </Box>
  );
};

export default Register;